import type { ReactNode } from 'react'

type Tone = 'info' | 'warning'

const tones: Record<Tone, { wrapper: string; icon: string }> = {
  info: {
    wrapper: 'border-sky-200 bg-sky-50 text-sky-900 dark:border-sky-900 dark:bg-sky-950 dark:text-sky-100',
    icon: 'text-sky-600 dark:text-sky-400',
  },
  warning: {
    wrapper:
      'border-brass-200 bg-brass-50 text-brass-900 dark:border-brass-800 dark:bg-brass-950/40 dark:text-brass-100',
    icon: 'text-brass-600 dark:text-brass-400',
  },
}

interface CalloutProps {
  title: string
  tone?: Tone
  children?: ReactNode
}

export function Callout({ title, tone = 'info', children }: CalloutProps) {
  return (
    <div className={`flex gap-3 rounded-xl border p-4 ${tones[tone].wrapper}`}>
      <svg
        viewBox="0 0 24 24"
        className={`mt-0.5 h-5 w-5 shrink-0 ${tones[tone].icon}`}
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        aria-hidden="true"
      >
        <circle cx="12" cy="12" r="9" />
        <path d="M12 8h.01M11 12h1v4h1" strokeLinecap="round" />
      </svg>
      <div className="min-w-0 text-sm">
        <p className="font-semibold">{title}</p>
        {children && <div className="mt-1 leading-relaxed opacity-90">{children}</div>}
      </div>
    </div>
  )
}
